import React from 'react';
import { Button } from '@material-ui/core';
import './Login.css';
import { auth, provider } from './firebase';

const Login = () => {
    const signIn = () => {
        auth.signInWithPopup(provider).catch((error) => alert(error.message))
    }
    return (
        <div className='login' >
            <div className="login__container">


                <img className="login__logo" src="https://fontmeme.com/permalink/201015/c3f00aee45ecbe61bbeac697b8a4866b.png" alt="accord_logo" />

                <Button onClick={signIn}>Sign In With Google</Button>
                <h3>Dev by Arefat Hyeredin</h3>
            </div>
        </div>
    )
}

export default Login
